import { render } from "./OnboardingCaregiver.vue?vue&type=template&id=e1d41252&scoped=true"
import script from "./OnboardingCaregiver.vue?vue&type=script&lang=js"
export * from "./OnboardingCaregiver.vue?vue&type=script&lang=js"

import "./OnboardingCaregiver.vue?vue&type=style&index=0&id=e1d41252&lang=css"
import "./OnboardingCaregiver.vue?vue&type=style&index=1&id=e1d41252&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1d41252"]])

export default __exports__